import axios from '@/libs/api.request'
var qs = require('qs');
// 获取列表数据
export const fetchTableList = (params) => {
    let data = params
    data = qs.stringify(data)
    return axios.request({
        url: '/teacher-video/student-video-list',
        data,
        method: 'post'
    })
};
// 获取学生下拉
export const fetchUserList = () => {

    return axios.request({
        url: '/teacher-video/student-list',

        method: 'post'
    })
};
// 改变状态
export const setStatus = (params) => {
    let data = params;
    data = qs.stringify(data);
    return axios.request({
        url: '/teacher-video/change-student-status',
        data,
        method: 'post'
    })
};